import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const projectItemTemplatesApi = {
    getProjectItemTemplates: (projectId: number): Observable<Dtos.GetProjectItemTemplatesResponse> => {
        //Create the request.
        let request: Dtos.GetProjectItemTemplates = new Dtos.GetProjectItemTemplates();

        request.trialId = projectId;

        //Send request.
        const response: Promise<Dtos.GetProjectItemTemplatesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getProjectItemTemplateById: (id: number): Observable<Dtos.GetProjectItemTemplateByIdResponse> => {
        //Create the request.
        let request: Dtos.GetProjectItemTemplateById = new Dtos.GetProjectItemTemplateById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetProjectItemTemplateByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setProjectItemTemplate: (projectItemTemplate: Dtos.ProjectItemTemplate, collection: Dtos.Collection): Observable<Dtos.SetProjectItemTemplateResponse> => {

        let request: Dtos.SetProjectItemTemplate = new Dtos.SetProjectItemTemplate();

        request.projectItemTemplate = projectItemTemplate;
        request.collection = collection;

        // send request
        const response: Promise<Dtos.SetProjectItemTemplateResponse> = client.post(request);

        return Observable.from(response);

    },
    createProjectItemTemplate: (projectId: number): Observable<Dtos.CreateProjectItemTemplateResponse> => {
        //Create the request.
        let request: Dtos.CreateProjectItemTemplate = new Dtos.CreateProjectItemTemplate();

        request.trialId = projectId;

        //Send request.
        const response: Promise<Dtos.CreateProjectItemTemplateResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateProjectItemTemplate: (projectItemTemplate: Dtos.ProjectItemTemplate, collection: Dtos.Collection): Observable<Dtos.ValidateProjectItemTemplateResponse> => {

        let request: Dtos.ValidateProjectItemTemplate = new Dtos.ValidateProjectItemTemplate();

        request.projectItemTemplate = projectItemTemplate;
        request.collection = collection;

        // send request
        const response: Promise<Dtos.ValidateProjectItemTemplateResponse> = client.post(request);

        return Observable.from(response);

    },
}